import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=50b43248&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=50b43248&prod&lang=scss&scoped=true"
import style1 from "./detail.vue?vue&type=style&index=1&id=50b43248&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b43248",
  null
  
)

export default component.exports